// src/Components/BannerSlider.jsx

import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

// Import the new dedicated stylesheet
import './BannerSlider.css';

import { db } from '../firebase'; 
import { collection, getDocs } from 'firebase/firestore';

function BannerSlider() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const bannersCollectionRef = collection(db, "banners");
        const querySnapshot = await getDocs(bannersCollectionRef);
        
        const bannerData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setBanners(bannerData);
      } catch (error) {
        console.error("Error fetching banners from Firestore: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  if (loading) {
    return (
      <div className="banner-section">
        <div className="container">
          <div className="skeleton-banner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="banner-section">
      <div className="container">
        <h3 className="section-title">
           Our Exciting Offers for You
        </h3>
        
        <Swiper 
          className="hero-swiper"
          modules={[Autoplay, Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          loop={banners.length > 1} 
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
        >
          {banners.map(banner => (
            <SwiperSlide key={banner.id} className="hero-slide">
              {/* ✅ REMOVED the wrapper div */}
              <img 
                src={banner.imageUrl} 
                alt={banner.fileName || 'Homepage Banner'} 
                className="banner-image" 
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default BannerSlider;